import React from "react";
import styled from "styled-components";
import customData from "../../data.json";
import ReactAudioPlayer from "react-audio-player";

// music
import backgroundMusic from "../../assets/audio/Second _Chance.mp3";

// style
const StyledFooter = styled.section`
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .footer-left {
  }
  .footer-middle {
    width: 30%;
    p {
      color: #707070;
      font-size: 0.5rem;
      a{
        color: #707070;
      :hover {
        color: black;
      }
      }
    
    }
  }
  .footer-right {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 0.5rem;
    position: relative;
  }
  // tablet
  @media screen and (min-width: 768px) {
    .footer-middle {
      p {
        font-size: 1rem;
      }
    }
  }

  // 720
  @media screen and (min-width: 1366px) {
    .footer-left {
      width: 30%;
    }
    .footer-right {
      width: 30%;
      padding-top: 0.4%;
    }
  }

   // 1920k screen
   @media screen and (min-width: 1920px) {
     .footer-right{
       padding-top: 0;
     }
    }
  }
`;

const Footer = () => {
  return (
    <StyledFooter>
      <div className="footer-left"></div>
      <div className="footer-middle">
        <p>
          &copy; {new Date().getFullYear()}{" "}
          <a
            href="https://webdev-im.netlify.app"
            target="_blank"
            rel="noreferrer"
          >
            {customData.footer.blogName}
          </a>
        </p>
      </div>
      <div className="footer-right">
        <ReactAudioPlayer src={backgroundMusic} autoPlay controls />
      </div>
    </StyledFooter>
  );
};

export default Footer;
